import { createSlice } from '@reduxjs/toolkit';
import { ITimesheet } from '../../../../dto';
import { setTimesheets } from '../actions';
import { MN_TIMESHEET, TYPE_LIST } from '../../../../common';

export interface TimesheetsState {
  data: ITimesheet[];
  loading: boolean;
  error: string | null;
}

const initialState: TimesheetsState = {
  data: [],
  loading: false,
  error: null,
};

export const timesheetsSlice = createSlice({
  name: `${MN_TIMESHEET}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTimesheets, (state, { payload }) => {
      state.data = payload;
    });
  },
});
